if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const freeShippingThreshold = Math.round(Number(this.getAttribute('data-free-shipping')) * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const cartTotal = Number(this.getAttribute('data-cart-total'));
      const freeShippingRemaining = cartTotal - freeShippingThreshold;
			
      let cartSliderWidth = 0;
      if ( freeShippingRemaining < 0 ) {
        this.querySelector('[data-js-free-shipping-text]').innerHTML = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this.#formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));
        cartSliderWidth = 100 - (Math.abs(freeShippingRemaining) * 100 / freeShippingThreshold);
      } else {
        this.querySelector('[data-js-free-shipping-text]').innerHTML = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        cartSliderWidth = 100;
      }
			if ( this.querySelector('[data-js-free-shipping-slider]') ) {
				this.querySelector('[data-js-free-shipping-slider]').style.width = `${cartSliderWidth}%`;
			}

    }
    
    #formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount + KROWN.settings.iso_code;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}

// ---------------------------------------------------------------------------
// StickerNotice — seuil cadeau plaquette de stickers
// ---------------------------------------------------------------------------
if ( typeof StickerNotice !== 'function' ) {

  class StickerNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const threshold = Math.round(
        Number(this.getAttribute('data-sticker-threshold')) *
        (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1)
      );
      const cartTotal = Number(this.getAttribute('data-cart-total'));
      const remaining = cartTotal - threshold;

      const textEl   = this.querySelector('[data-js-sticker-notice-text]');
      const sliderEl = this.querySelector('[data-js-sticker-notice-slider]');

      // Le bloc preview visuel est un frère de <sticker-notice>, pas un enfant
      const wrapper  = this.closest('.kt-sidebar__inner-element, .kt-cart__subtotal-widget');
      const previewEl = wrapper ? wrapper.querySelector('[data-js-sticker-gift-preview]') : null;

      if (!textEl) return;

      let sliderWidth = 0;
      let eligible = false;

      if (remaining < 0) {
        const remainingFormatted = this._formatMoney(Math.abs(remaining), KROWN.settings.shop_money_format);
        const tpl = (window.KROWN.settings.locales.sticker_notice_remaining_to_gift)
          ? window.KROWN.settings.locales.sticker_notice_remaining_to_gift
          : 'Plus que {{ remaining_amount }} pour recevoir votre plaquette de stickers offerte !';
        textEl.innerHTML = tpl.replace('{{ remaining_amount }}', remainingFormatted);
        sliderWidth = 100 - (Math.abs(remaining) * 100 / threshold);
        eligible = false;
      } else {
        const msg = (window.KROWN.settings.locales.sticker_notice_gift_eligible)
          ? window.KROWN.settings.locales.sticker_notice_gift_eligible
          : '🎉 Votre plaquette de stickers offerte est dans votre commande !';
        textEl.innerHTML = msg;
        sliderWidth = 100;
        eligible = true;
      }

      if (sliderEl) {
        sliderEl.style.width = `${Math.min(sliderWidth, 100)}%`;
      }

      if (previewEl) {
        previewEl.style.display = eligible ? 'flex' : 'none';
      }

    }

    _formatMoney(cents, format) {

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';
        if (isNaN(number) || number === null) { return 0; }
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';
        return dollarsAmount + centsAmount + KROWN.settings.iso_code;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);

    }

  }

  if ( typeof customElements.get('sticker-notice') == 'undefined' ) {
    customElements.define('sticker-notice', StickerNotice);
  }

}